export const Icons = Object.freeze({
    ROCKET: 'EnRocketIcon',
});